/*
 * https://www.algolia.com/doc/api-reference/widgets/infinite-hits/js/
 */
import { pagination } from 'instantsearch.js/es/widgets'
import { containers } from './selectors'

export let paginationWidget

const container = document.querySelector(containers.pagination)
if (container !== undefined && container !== null) {
  paginationWidget = pagination({
    container: containers.pagination,
    showFirst: false,
    cssClasses: {
      root: 'flex',
      noRefinementRoot: 'opacity-0 hidden',
      list: 'text-xs font-medium flex my-8 font-bold text-blue-700',
      item: 'rounded-sm flex bg-blue-50 hover:bg-blue-75 items-center justify-center mx-0.5',
      link: 'w-8 h-8 flex items-center justify-center',
      selectedItem: 'bg-blue-600 text-white hover:bg-blue-800 antialiased',
      templates: {
        first: '«',
      },
    },
  })
}
